import { MdCheck } from 'react-icons/md';
import type { ComponentPropsWithRef, ReactNode } from 'react';

import { cn } from '../lib/cn';

export type CheckboxProps = Omit<ComponentPropsWithRef<'input'>, 'type'> & {
  label: ReactNode;
  /** Classe du `<label>` englobant. */
  wrapperClassName?: string;
};

/** Case à cocher stylée : l'input natif reste présent pour l'accessibilité. */
export function Checkbox({ label, className, wrapperClassName, ...props }: CheckboxProps) {
  return (
    <label
      className={cn(
        'group inline-flex cursor-pointer select-none items-center gap-2.5 text-sm text-content-muted',
        wrapperClassName,
      )}
    >
      <span className="relative flex size-[18px] shrink-0 items-center justify-center">
        <input type="checkbox" className={cn('peer sr-only', className)} {...props} />
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-[5px] border border-border-input/50 bg-white transition-colors peer-checked:border-brand-600 peer-checked:bg-brand-600 peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-brand-600"
        />
        <MdCheck
          aria-hidden="true"
          className="relative size-3.5 text-white opacity-0 transition-opacity peer-checked:opacity-100"
        />
      </span>
      {label}
    </label>
  );
}
